import client from "./client/index.js";
import getSingle from "./get-single.js";
import getAll from "./get-all.js";

export default {
	client,
	getSingle,
	getAll,
};
